import * as React from 'react';

import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';

import { GeneralServerSettingsSubspaceState } from '../../../../app/spaces/ServerSettingsSpace/GeneralServerSettingsSubspace';
import { Messages } from '../../../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../../../sessionManagement/SessionManagementService';
import { ToasterService, ToastType } from '../../../../ts/services/ToasterService';
import { coordinatorSubmitFailedHandler, coordinatorSubmitHandler } from '../common/GeneralToastHandlers';
import ReactSiteSettingsForServerAdmin from '../site-settings/ReactSiteSettingsForServerAdminSubFormik';
import { ReactSiteSettingsForSiteAdmin } from '../site-settings/ReactSiteSettingsForSiteAdminSubFormik';
import { ReactServerSettings } from './ReactServerSettingsSubFormik';

export function GeneralServerSettingsCoordinator(props: GeneralServerSettingsSubspaceState) {
  const sessionService = getSessionManagementServiceInstance();

  return (
    <SettingsCoordinator
      onSubmit={coordinatorSubmitHandler}
      onSubmitFailure={coordinatorSubmitFailedHandler}
      onResetToDefaultSuccess={showResetSuccessToast}
      showResetToDefaultButton={true}
    >

      {!sessionService.isSessionMultiSite() &&
      <ReactSiteSettingsForServerAdmin settings={props}/>}

      {!sessionService.isSessionMultiSite() &&
      <ReactSiteSettingsForSiteAdmin settings={props}/>}

      <ReactServerSettings
        settings={props.serverSettings}
        serverTimestamps={props.serverTimestamps}
      />
    </SettingsCoordinator>
  );
}

async function showResetSuccessToast() {
  ToasterService.getInstance().pop({type: ToastType.Info, text: Messages.resetServerSettingsSuccess()});
}
